define.alias("ember-useragent/helpers/user-agent", "media/helpers/user-agent");